import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "animate-shimmer bg-shimmer visible bg-gradient-to-r from-[#EEE] from-10% via-[#DEDEDE] via-15% to-[#EEE] to-20% bg-no-repeat",
  },
  variants: {
    rounded: {
      sm: "rounded-sm",
      default: "rounded",
      md: "rounded-md",
      lg: "rounded-lg",
      full: "rounded-full",
    },
  },
  defaultVariants: {
    rounded: "sm",
  },
});
interface IProps {
  height?: string | number;
  width?: string | number;
  rounded?: VariantProps<typeof styles>["rounded"];
}

const Shimmer = ({ height = 400, width = "100%", rounded = "sm" }: IProps) => {
  const { base } = styles({ rounded });

  const calculateWidth = () => {
    if (typeof width === "string") {
      let intWidth = parseInt(width);
      intWidth = intWidth * 10;

      if (width.includes("%")) return `${intWidth}%`;

      return `${intWidth}px`;
    } else {
      return `${width * 10}px`;
    }
  };

  const getHeight = () => {
    if (typeof height === "string") return height;

    return `${height}px`;
  };

  return (
    <div
      className={base()}
      style={{
        width,
        height,
        backgroundSize: `${calculateWidth()} ${getHeight()}`,
      }}
    />
  );
};

export default Shimmer;
